<template>
	<div class="d-flex align-center justify-space-between">
		<div v-if="hideButton" style="width: 24px"></div>
		<v-btn
			v-else
			fab
			color="primary"
			height="42px"
			width="42px"
			:disabled="loading"
			@click="onClickBtn()"
		>
			<v-icon color="white" size="28">{{ icon }}</v-icon>
		</v-btn>
		<p
			class="mb-0 text-center"
			:class="{
				'text-h6': isMobile,
				'text-h5': !isMobile,
				'font-weight-medium': !isMobile,
			}"
			v-html="title"
		></p>
		<div style="width: 24px"></div>
	</div>
</template>

<script>
export default {
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		isMobile: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			required: true,
		},
		hideButton: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: String,
			default: "mdi-refresh"
		}
	},
	methods: {
		onClickBtn() {
			this.$emit("click:btn");
		},
	},
};
</script>